import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';


const state = {
  serviceGroups: {},
};

const mutations = {
  [types.SET_SERVICE_GROUPS]: (state, serviceGroups) => {
    state.serviceGroups = serviceGroups;
  },
};

const getters = {
  getServiceGroups: state => Object.values(state.serviceGroups),
  getServiceGroupById: state => id => state.serviceGroups[id],
  getServiceGroupsByPlace: state => place => place.serviceGroupIds.map(
    groupId => state.serviceGroups[groupId],
  ),
};

const actions = {
  async loadServiceGroups({ commit, rootState }) {
    return loadDataForSnapshot(
      commit, rootState, types.SET_SERVICE_GROUPS, config.ICOOL.API.SERVICE_GROUPS_PATH,
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
